
import { Component, Vue } from 'vue-property-decorator'
import { DocumentsApi } from '@/api/methods/content/DocumentsApi'
import PdfViewerTemplate from '@/components/templates/PdfViewerTemplate.vue'
import DownloadUtils from '@/utils/DownloadUtils'

/**
 * 先生用マニュアルPDF
 */
@Component({
  components: {
    PdfViewerTemplate,
  },
})
export default class ManualTeacherPdf extends Vue {
  /** 処理完了フラグ */
  private isCompleted = false

  /** PDFデータ(blob型) */
  private pdfBlob!: Blob

  /**
   * 読み込み時処理
   */
  private async created(): Promise<void> {
    this.$loading.start()

    // マニュアルのBlobデータ取得
    this.pdfBlob = await DocumentsApi.getManualTeacher()

    this.$loading.complete()

    this.isCompleted = true
  }

  /**
   * ダウンロード処理
   */
  private downloadPdf(): void {
    DownloadUtils.pdf(this.pdfBlob, 'gpass_manual_teacher.pdf')
  }

  /**
   * 表示待ちタイムアウト時イベント
   */
  private eventTimeout(): void {
    alert('PDFの表示に時間が掛かっています。\n表示されない場合、ダウンロード機能をお試しください。')
  }
}
